<template>
  <div class="companylistfilter">
    <side-bar>
      <div slot="filter" class="companyFilterTitle">
        <span class="companyFilterText">过滤器</span>
        <span class="filter-btn">
             <img src="../../../assets/images/customerlist/setup.png" style="width: 16px;height: 16px"
                  @click="dialogFormVisible1=true"/>
        </span>
      </div>
      <div slot="sideFilter-contain">
        <el-scrollbar style="height:100%">
          <div style="width:200px;height:calc(100vh - 142px);font-size: 14px;">
            <div class="sidefilter-title" @click="getAllCompany" :class="{allCompanyCheck:currentIndex===0}">
              <span class="companyTitleText">所有公司</span>
              <span class="sideFilterNum" v-if="companyTotal > 999">999+</span>
              <span class="sideFilterNum" v-if="companyTotal < 999">{{ companyTotal }}</span>
            </div>
            <div
                v-for="(item,index) in companySideFilter"
                :key="index"
                :class="{companyFilterIsActive:currentIndex===item.id&&currentIndex!==0}"
                @mouseover="mouseOverClick(index)"
                @mouseout="mouseOutClick"
            >
              <div class="sidefilter-title" v-if="item.display===true">
                <span class="companyTitleText" @click="companyFilter(item.id)">{{ item.name }}</span>
                <span class="sideFilterNum" v-if="moseOver!==index&&item._count>999">999+</span>
                <span class="sideFilterNum" v-if="moseOver!==index&&item._count<999">{{ item._count }}</span>
                <span class="sideFilterNum" v-show="moseOver===index">
                       <img src="./../../../assets/images/fieldmanage/rivese.png"
                            @click="modifyFilter(index,item.id)" style="width: 16px;height: 16px"/>
                </span>
              </div>

            </div>

            <el-dialog :close-on-click-modal="false" title="编辑过滤器" :visible.sync="dialogFormVisible2"
                       custom-class="sidebarDialog" style="text-align: left;">

              <div class="filterName">
                <el-row :gutter="20">
                  <el-col :span="4" style="padding-right: 0px">
                    <div class="text"><span class="biaoji">*</span>过滤器名称</div>
                  </el-col>
                  <el-col :span="20">
                    <el-input v-model="filterName" autocomplete="off" style="width: 100%" maxlength="15"></el-input>
                  </el-col>
                </el-row>
              </div>
              <div class="visibleRange">
                <el-row :gutter="20">
                  <el-col :span="4">
                    <div class="textRange">
                      可见范围
                    </div>
                  </el-col>
                  <el-col :span="20">
                    <div>
                      <el-radio v-model="rangeRadio" label="1">仅自己可见</el-radio>
                      <el-radio v-model="rangeRadio" label="2">全员可见</el-radio>
                    </div>
                  </el-col>
                </el-row>
              </div>
              <div class="company">
                <el-row>
                  <el-col :span="4">
                    <div class="filterCompanyText">公司</div>
                  </el-col>
                  <el-col :span="20">
                    <el-select v-model="companyValue"
                               clearable
                               multiple
                               placeholder="请选择或者搜索公司"
                               style="width: 100%;position: relative">
                      <div>
                        <el-input
                            placeholder="可搜索"
                            v-model="companySelect"
                            clearable
                            style="position: absolute;z-index: 999;top: 0;width: 100%"
                            @input="inputCompanyInput"
                        >
                        </el-input>
                      </div>
                      <div>
                        <el-option value="" label="无" style="margin-top: 40px"></el-option>
                      </div>
                      <div v-if="selectCompanyList.length > 0">
                        <el-option
                            v-for="item in selectCompanyList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                      </div>
                    </el-select>
                  </el-col>
                </el-row>
              </div>

              <div class="level">
                <el-row :gutter="20">
                  <el-col :span="4">
                    <div class="textPriority">等级</div>
                  </el-col>
                  <el-col :span="20">
                    <div>
                      <el-radio v-model="levelRadio" label="1">全部</el-radio>
                      <el-radio v-model="levelRadio" label="2">普通</el-radio>
                      <el-radio v-model="levelRadio" label="3">vip</el-radio>
                    </div>
                  </el-col>
                </el-row>
              </div>


              <div class="emailSuffix">
                <el-row :gutter="20">
                  <el-col :span="4" style="padding-right: 0">
                    <div class="emailSuffixText">公司邮箱后缀</div>
                  </el-col>
                  <el-col :span="20">
                    <div>
                      <el-radio v-model="emailSuffixRadio" label="1">全部</el-radio>
                      <el-radio v-model="emailSuffixRadio" label="2">为空</el-radio>
                      <el-radio v-model="emailSuffixRadio" label="3">不为空</el-radio>
                    </div>
                  </el-col>
                </el-row>
              </div>

              <div class="filterLiaisonPerson">
                <el-row :gutter="20">
                  <el-col :span="4">
                    <div class="liaisonPersonText">公司联系人</div>
                  </el-col>
                  <el-col :span="20">
                    <div>
                      <el-radio v-model="liaisionRadio" label="1">全部</el-radio>
                      <el-radio v-model="liaisionRadio" label="2">为空</el-radio>
                      <el-radio v-model="liaisionRadio" label="3">不为空</el-radio>
                    </div>
                  </el-col>
                </el-row>
              </div>

              <div class="filterLiaisonPhone">
                <el-row :gutter="20">
                  <el-col :span="4">
                    <div class="liaisonPhoneText">联系人电话</div>
                  </el-col>
                  <el-col :span="20">
                    <div>
                      <el-radio v-model="liaisionPhoneRadio" label="1">全部</el-radio>
                      <el-radio v-model="liaisionPhoneRadio" label="2">为空</el-radio>
                      <el-radio v-model="liaisionPhoneRadio" label="3">不为空</el-radio>
                    </div>
                  </el-col>
                </el-row>
              </div>


              <div class="filterLiaisonEmail">
                <el-row :gutter="20">
                  <el-col :span="4">
                    <div class="LiaisonEmailText">联系人邮箱</div>
                  </el-col>
                  <el-col :span="20">
                    <div>
                      <el-radio v-model="liaisionEmailRadio" label="1">全部</el-radio>
                      <el-radio v-model="liaisionEmailRadio" label="2">为空</el-radio>
                      <el-radio v-model="liaisionEmailRadio" label="3">不为空</el-radio>
                    </div>
                  </el-col>
                </el-row>
              </div>


              <div class="Responsible">
                <el-row :gutter="20">
                  <el-col :span="12">
                    <div class="ResponsibleGroup">
                      <el-row :gutter="20">
                        <el-col :span="8">
                          <div class="ResponsibleGroupText">负责组</div>
                        </el-col>
                        <el-col :span="16">
                          <div>
                            <el-select v-model="ResponsibleGroup"
                                       placeholder="请选择"
                                       multiple
                                       style="position: relative"
                            >
                              <div>
                                <el-input
                                    v-model="createPersonInput"
                                    autocomplete="off"
                                    style="width: 100%;position: absolute;z-index: 999;top: 0"
                                    placeholder="可搜索"
                                    class="kesousuo"
                                    @input="inputSelectFilterGroup"

                                ></el-input>
                              </div>
                              <div>
                                <el-option value="" label="无" style="margin-top: 40px"></el-option>
                              </div>
                              <div v-if="selectFilterGroup.length > 0">
                                <el-option
                                    v-for="item in selectFilterGroup"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                              </div>

                            </el-select>
                          </div>
                        </el-col>
                      </el-row>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <el-row :gutter="20">
                      <el-col :span="8">
                        <div class="ResponsiblePersonText">负责人</div>
                      </el-col>
                      <el-col :span="16">
                        <div class="focus">
                          <div>
                            <el-select
                                v-model="ResponsiblePerson"
                                placeholder="请选择"
                                multiple
                                style="position: relative"
                            >
                              <div>
                                <el-input
                                    v-model="focusPersonInput"
                                    autocomplete="off"
                                    style="width: 100%;position: absolute;z-index: 999;top: 0"
                                    placeholder="可搜索"
                                    @input="inputSelectFilterPerson"
                                    class="kesousuo"
                                ></el-input>
                              </div>
                              <div>
                                <el-option value="" label="无" style="margin-top: 40px"></el-option>
                              </div>
                              <div v-if="selectFilterPerson.length > 0">
                                <el-option
                                    v-for="item in selectFilterPerson"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                              </div>

                            </el-select>
                          </div>

                        </div>
                      </el-col>
                    </el-row>

                  </el-col>
                </el-row>


              </div>

              <div class="filterAddTime">

                <div class="fliterAddTimeCon">
                  <el-row :gutter="20">
                    <el-col :span="4">
                      <div class="fliterAddTimeText">添加日期</div>
                    </el-col>
                    <el-col :span="20">
                      <div class="customerFilterBlock">
                        <el-date-picker
                            v-model="addTime"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始时间"
                            end-placeholder="结束日期"
                            style="width:100%"
                        >
                        </el-date-picker>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </div>
              <div class="filterUpdateTime">

                <div class="filterUpdateTimeCon">
                  <el-row :gutter="20">
                    <el-col :span="4">
                      <div class="filterUpdateTimeText">更新日期</div>
                    </el-col>
                    <el-col :span="20">
                      <div class="customerFilterBlock">
                        <el-date-picker
                            v-model="updateTime"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width:100%"
                        >
                        </el-date-picker>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </div>
              <div slot="footer" class="dialog-footer">
                <el-button @click="IsDeleteCompanyFilter" style="float: left" type="danger">删除</el-button>
                <el-button @click="dialogFormVisible2 = false">取 消</el-button>
                <el-button type="primary" @click="modifyCompanyFilter">确 定</el-button>
              </div>
            </el-dialog>
            <div class="customize-filter">

              <el-button type="text" @click="customizeFilter">
                <i class="el-icon-circle-plus-outline"></i>
                <span class="siderFilter">自定义过滤器</span>
              </el-button>
              <el-dialog title="自定义过滤器" :close-on-click-modal="false" :visible.sync="dialogFormVisible"
                         custom-class="sidebarDialog" style="text-align: left;">


                <div class="filterName">
                  <el-row :gutter="20">
                    <el-col :span="4" style="padding-right: 0px">
                      <div class="text"><span class="biaoji">*</span>过滤器名称</div>
                    </el-col>
                    <el-col :span="20">
                      <el-input v-model="filterName" autocomplete="off" style="width: 100%" maxlength="15"
                                placeholder="请输入过滤器名称"></el-input>
                    </el-col>
                  </el-row>
                </div>
                <div class="visibleRange">
                  <el-row :gutter="20">
                    <el-col :span="4">
                      <div class="textRange">
                        可见范围
                      </div>
                    </el-col>
                    <el-col :span="20">
                      <div>
                        <el-radio v-model="rangeRadio" label="1">仅自己可见</el-radio>
                        <el-radio v-model="rangeRadio" label="2">全员可见</el-radio>
                      </div>
                    </el-col>
                  </el-row>
                </div>


                <div class="company">
                  <el-row>
                    <el-col :span="4">
                      <div class="filterCompanyText">公司</div>
                    </el-col>
                    <el-col :span="20">

                      <el-select v-model="companyValue"
                                 clearable
                                 multiple
                                 placeholder="请选择或者搜索公司"
                                 style="width: 100%;position: relative">
                        <div>
                          <el-input
                              placeholder="可搜索"
                              v-model="companySelect"
                              clearable
                              style="position: absolute;z-index: 999;top: 0;width: 100%"
                              @input="inputCompanyInput"
                          >
                          </el-input>
                        </div>
                        <div>
                          <el-option value="" label="无" style="margin-top: 40px"></el-option>
                        </div>
                        <div v-if="selectCompanyList.length > 0">
                          <el-option
                              v-for="item in selectCompanyList"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id">
                          </el-option>
                        </div>
                      </el-select>
                    </el-col>
                  </el-row>
                </div>

                <div class="level">
                  <el-row :gutter="20">
                    <el-col :span="4">
                      <div class="textPriority">等级</div>
                    </el-col>
                    <el-col :span="20">
                      <div>
                        <el-radio v-model="levelRadio" label="1">全部</el-radio>
                        <el-radio v-model="levelRadio" label="2">普通</el-radio>
                        <el-radio v-model="levelRadio" label="3">vip</el-radio>
                      </div>
                    </el-col>
                  </el-row>
                </div>


                <div class="emailSuffix">
                  <el-row :gutter="20">
                    <el-col :span="4" style="padding-right: 0">
                      <div class="emailSuffixText">公司邮箱后缀</div>
                    </el-col>
                    <el-col :span="20">
                      <div>
                        <el-radio v-model="emailSuffixRadio" label="1">全部</el-radio>
                        <el-radio v-model="emailSuffixRadio" label="2">为空</el-radio>
                        <el-radio v-model="emailSuffixRadio" label="3">不为空</el-radio>
                      </div>
                    </el-col>
                  </el-row>
                </div>

                <div class="filterLiaisonPerson">
                  <el-row :gutter="20">
                    <el-col :span="4">
                      <div class="liaisonPersonText">公司联系人</div>
                    </el-col>
                    <el-col :span="20">
                      <div>
                        <el-radio v-model="liaisionRadio" label="1">全部</el-radio>
                        <el-radio v-model="liaisionRadio" label="2">为空</el-radio>
                        <el-radio v-model="liaisionRadio" label="3">不为空</el-radio>
                      </div>
                    </el-col>
                  </el-row>
                </div>

                <div class="filterLiaisonPhone">
                  <el-row :gutter="20">
                    <el-col :span="4">
                      <div class="liaisonPhoneText">联系人电话</div>
                    </el-col>
                    <el-col :span="20">
                      <div>
                        <el-radio v-model="liaisionPhoneRadio" label="1">全部</el-radio>
                        <el-radio v-model="liaisionPhoneRadio" label="2">为空</el-radio>
                        <el-radio v-model="liaisionPhoneRadio" label="3">不为空</el-radio>
                      </div>
                    </el-col>
                  </el-row>
                </div>


                <div class="filterLiaisonEmail">
                  <el-row :gutter="20">
                    <el-col :span="4">
                      <div class="LiaisonEmailText">联系人邮箱</div>
                    </el-col>
                    <el-col :span="20">
                      <div>
                        <el-radio v-model="liaisionEmailRadio" label="1">全部</el-radio>
                        <el-radio v-model="liaisionEmailRadio" label="2">为空</el-radio>
                        <el-radio v-model="liaisionEmailRadio" label="3">不为空</el-radio>
                      </div>
                    </el-col>
                  </el-row>
                </div>


                <div class="Responsible">
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <div class="ResponsibleGroup">
                        <el-row :gutter="20">
                          <el-col :span="8">
                            <div class="ResponsibleGroupText">负责组</div>
                          </el-col>
                          <el-col :span="16">
                            <div>
                              <el-select v-model="ResponsibleGroup"
                                         placeholder="请选择"
                                         multiple
                                         style="position: relative"
                              >
                                <div>
                                  <el-input
                                      v-model="createPersonInput"
                                      autocomplete="off"
                                      style="width: 100%;position:absolute;z-index: 999;top: 0"
                                      placeholder="可搜索"
                                      class="kesousuo"
                                      @input="inputSelectFilterGroup"
                                  ></el-input>
                                </div>
                                <div>
                                  <el-option value="" label="无" style="margin-top: 40px"></el-option>
                                </div>
                                <div v-if="selectFilterGroup.length > 0">
                                  <el-option
                                      v-for="item in selectFilterGroup"
                                      :key="item.id"
                                      :label="item.name"
                                      :value="item.id">
                                  </el-option>
                                </div>

                              </el-select>
                            </div>
                          </el-col>
                        </el-row>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <el-row :gutter="20">
                        <el-col :span="8">
                          <div class="ResponsiblePersonText">负责人</div>
                        </el-col>
                        <el-col :span="16">
                          <div class="focus">
                            <div>
                              <el-select
                                  v-model="ResponsiblePerson"
                                  placeholder="请选择"
                                  multiple
                                  style="position: relative"
                              >
                                <div>
                                  <el-input
                                      v-model="focusPersonInput"
                                      autocomplete="off"
                                      style="width: 100%;position: absolute;z-index: 999;top: 0"
                                      @input="inputSelectFilterPerson"
                                      placeholder="可搜索"
                                      class="kesousuo"></el-input>
                                </div>
                                <div>
                                  <el-option value="" label="无" style="margin-top: 40px"></el-option>
                                </div>
                                <div v-if="selectFilterPerson.length > 0">
                                  <el-option
                                      v-for="item in selectFilterPerson"
                                      :key="item.id"
                                      :label="item.name"
                                      :value="item.id">
                                  </el-option>
                                </div>

                              </el-select>
                            </div>

                          </div>
                        </el-col>
                      </el-row>

                    </el-col>
                  </el-row>


                </div>

                <div class="filterAddTime">

                  <div class="fliterAddTimeCon">
                    <el-row :gutter="20">
                      <el-col :span="4">
                        <div class="fliterAddTimeText">添加日期</div>
                      </el-col>
                      <el-col :span="20">
                        <div class="customerFilterBlock">
                          <el-date-picker
                              v-model="addTime"
                              type="datetimerange"
                              range-separator="至"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期"
                              style="width:100%"
                          >
                          </el-date-picker>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </div>
                <div class="filterUpdateTime">

                  <div class="filterUpdateTimeCon">
                    <el-row :gutter="20">
                      <el-col :span="4">
                        <div class="filterUpdateTimeText">更新日期</div>
                      </el-col>
                      <el-col :span="20">
                        <div class="customerFilterBlock">
                          <el-date-picker
                              v-model="updateTime"
                              type="datetimerange"
                              range-separator="至"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期"
                              style="width:100%"
                          >
                          </el-date-picker>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </div>
                <div slot="footer" class="dialog-footer">

                  <el-button @click="cancelFilter">取 消</el-button>
                  <el-button type="primary" @click="addCompanyFilter">确 定</el-button>
                </div>
              </el-dialog>


            </div>
          </div>
        </el-scrollbar>
      </div>

    </side-bar>
    <el-dialog
        title="删除过滤器"
        :visible.sync="dialogVisible"
        width="30%"
    >
      <span>是否删除该过滤器</span>
      <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="deleteCompanyFilter">确 定</el-button>
  </span>
    </el-dialog>
    <el-dialog title="配置过滤器" :visible.sync="dialogFormVisible1" custom-class="sidebarDialog" style="text-align: left;"
               :close-on-click-modal="false">

      <div class="companyFilterContain">
        <div class="companyFilterNotShow">
          <div style="font-weight: 600;font-size: 14px">未显示</div>
          <div class="notShowCon">
            <el-scrollbar>
              <div style="width: 100%;height: 400px">
                <div v-for="(item,index) in companyFilterList.list">
                  <div
                      class="notShowAddTime"
                      :key="index"
                      @click="filterToRight(item.id)"
                      v-if="!item.display"
                  >
                    <div>{{ item.name }}</div>
                  </div>
                </div>

              </div>
            </el-scrollbar>

          </div>
        </div>
        <div class="companyFilterShow">
          <div style="font-weight: 600;font-size: 14px">已显示</div>
          <div class="showCon">
            <el-scrollbar style="height: 100%">
              <div style="width: 100%;height: 400px">
                <div class="showCompanyLevel">
                  <span>所有公司</span>
                </div>
                <div id="companyFilterResort">
                  <div v-for="(item,index) in companyFilterList.list">
                    <div
                        class="showCompanyLevel"
                        :key="index"
                        @click="filterLeft(item.id)"
                        v-if="item.display"
                        style="cursor: pointer"
                    >
                      <span>{{ item.name }}</span>
                      <div @mouseenter="resortCompanyFilter" class="">
                        <img src="../../../assets/images/workorder/adjust1.png"
                             style="width: 16px;height: 16px;cursor: move">
                      </div>
                    </div>
                  </div>

                </div>

                <!-- <div class="showDescribe">
                 <span style="overflow: hidden;width: 150px;white-space: nowrap;text-overflow: ellipsis">我的名字是长的长的长的长的长的</span>
                 <div>
                     <img src="../../../assets/images/workorder/adjust1.png" style="width: 16px;height: 16px">
                 </div>
             </div>-->


              </div>
            </el-scrollbar>

          </div>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="cacelFilter">取 消</el-button>
        <el-button type="primary" @click="filterDisplay">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import SideBar from "../../workorder/sidebar/SideBar";
import Sortable from "sortablejs";

export default {
  name: "CompanyListFliter",
  components: {
    SideBar
  },
  data() {
    return {
      dialogTableVisible: false,
      dialogFormVisible: false,
      dialogFormVisible1: false,
      dialogFormVisible2: false,
      dialogVisible: false,
      checkList: ['选项1', '选项2'],
      checkList1: ['选项1', '选项2'],
      acceptanceGroup: '',
      data1: [],
      time1: [],
      check: [],
      acceptancePerson: '',
      createPerson: '',
      focusPerson: '',
      field: '',
      fieldLong: '',
      isActive: 0,
      filterName: '',
      groupInput: '',
      personInput: '',
      createPersonInput: '',
      focusPersonInput: '',
      companyValue: [],
      companySelect: '',
      rangeRadio: '1',
      radioRange: '',
      levelRadio: '1',
      grade: '',
      emailSuffixRadio: '1',
      mailSuffixIsNull: '',
      liaisionRadio: '1',
      lisisonIsNull: '',
      liaisionPhoneRadio: '1',
      telIsNull: '',
      liaisionEmailRadio: '1',
      mailIsNull: '',
      ResponsibleGroup: [],
      ResponsiblePerson: [],
      addTime: [],
      updateTime: [],
      companyFilterList: {
        list: [],
      },
      clientCompany: {
        list: []
      },
      pageSize: 10,
      currentPage: 1,
      currentIndex: 0,
      accountPerson: {
        list: []
      },
      accountGroup: {
        list: []
      },
      moseOver: '',
      filterIndex: '',
      companySideFilter: [],
      companyFlterId: '',
      tatol: [],
      companyTotal: 0,
      sideFilterList: [],
      resortFilter: [],
      selectFilterPerson: [],
      selectFilterGroup: [],
      selectCompanyList: []

    }
  },
  props: {
    clientCompanyTotal: Number,
    companyList: {
      type: Array,
      default() {
        return []
      }
    },
    companySearchNum: Number
  },
  mounted() {
    this.getClientCompany()
    this.getCompanyFilter()
    this.getAccountGroup()
    this.getShowFilter()
    this.getAccountPerson()
  },
  methods: {
    /* 获取过滤器中公司的下拉列表中的值*/
    getClientCompany() {
      this.$http.get('/api/client-company/page?num=' + this.pageSize + '&page=' + this.currentPage)
          .then(response => {
            this.clientCompany.list = response.data.data.content;
            this.selectCompanyList = response.data.data.content;
            this.companyTotal = response.data.data.totalElements
            console.debug('FieldApiExample field page:', this.clientCompany);
          })
    },
    /*1.获取公司列表过滤器*/
    getCompanyFilter() {
      this.sideFilter = []
      this.$http.get('/api/filter/list?type=COMPANY').then(response => {
        this.companyFilterList.list = response.data.data;
        console.debug('FieldApiExample field page:', this.clientCompany);
      })

    },
    getShowFilter() {
      this.$http.get('/api/filter/list?display=true&type=COMPANY').then(response => {
        this.companySideFilter = response.data.data;
      })


    },

    addCompanyFilter() {
      if (this.rangeRadio === '1') {
        this.radioRange = 'UID'
      }
      if (this.rangeRadio === '2') {
        this.radioRange = 'MID'
      }
      if (this.levelRadio === '1') {
        this.grade = null
      }
      if (this.levelRadio === '2') {
        this.grade = 'NORMAL'
      }
      if (this.levelRadio === '3') {
        this.grade = 'VIP'
      }
      if (this.liaisionRadio === '1') {
        this.lisisonIsNull = null
      }
      if (this.liaisionRadio === '2') {
        this.lisisonIsNull = true
      }
      if (this.liaisionRadio === '3') {
        this.lisisonIsNull = false
      }
      if (this.liaisionPhoneRadio === '1') {
        this.telIsNull = null
      }
      if (this.liaisionPhoneRadio === '2') {
        this.telIsNull = true
      }
      if (this.liaisionPhoneRadio === '3') {
        this.telIsNull = false
      }
      if (this.liaisionEmailRadio === '1') {
        this.mailIsNull = ''
      }
      if (this.liaisionEmailRadio === '2') {
        this.mailIsNull = true
      }
      if (this.liaisionEmailRadio === '3') {
        this.mailIsNull = false
      }
      if (this.mailSuffixIsNull === '1') {
        this.mailSuffixIsNull = null
      }
      if (this.mailSuffixIsNull === '2') {
        this.mailSuffixIsNull = true
      }
      if (this.mailSuffixIsNull === '3') {
        this.mailSuffixIsNull = false
      }
      if (this.addTime === null)
        this.addTime = []
      if (this.updateTime === null)
        this.updateTime = []
      if (this.filterName !== '') {
        this.$http.post('/api/filter/company', {

          companyIds: this.companyValue,
          filterBaseInfo: {
            name: this.filterName,
            scope: this.radioRange,
            type: "COMPANY"
          },
          grade: this.grade,
          groupIds: this.ResponsibleGroup,
          principalIds: this.ResponsiblePerson,
          createTimeBefore: this.addTime[0],
          createTimeAfter: this.addTime[1],
          updateTimeBefore: this.updateTime[0],
          updateTimeAfter: this.updateTime[1],
          mailSuffix: this.mailSuffixIsNull,
          contactPerson: this.lisisonIsNull,
          contactPersonTel: this.telIsNull,
          contactPersonMail: this.mailIsNull,

        }).then(res => {
          if (res.data.code === '0') {
            this.$message.success('添加过滤器成功')
          }
          this.getShowFilter()
        })
        this.dialogFormVisible = false
      } else
        this.$message('请填写过滤器的名称')

    },
    cancelFilter() {
      this.ResponsibleGroup = []
      this.dialogFormVisible = false
    },

    //获取负责组下拉列表值
    getAccountGroup() {
      this.$http.get('/api/account/group').then(res => {
        this.accountGroup.list = res.data.data
        this.selectFilterGroup = res.data.data
      })

    },

    //获取负责人的下拉列表值
    getAccountPerson() {
      this.$http.get('/api/account/principals?groupIds=%20').then(res => {
        this.accountPerson.list = res.data.data
        this.selectFilterPerson = res.data.data
      })
    },
    modifyCompanyFilter() {
      if (this.rangeRadio === '1') {
        this.radioRange = 'UID'
      }
      if (this.rangeRadio === '2') {
        this.radioRange = 'MID'
      }
      if (this.levelRadio === '1') {
        this.grade = null
      }
      if (this.levelRadio === '2') {
        this.grade = 'NORMAL'
      }
      if (this.levelRadio === '3') {
        this.grade = 'VIP'
      }
      if (this.liaisionRadio === '1') {
        this.lisisonIsNull = null
      }
      if (this.liaisionRadio === '2') {
        this.lisisonIsNull = true
      }
      if (this.liaisionRadio === '3') {
        this.lisisonIsNull = false
      }
      if (this.liaisionPhoneRadio === '1') {
        this.telIsNull = null
      }
      if (this.liaisionPhoneRadio === '2') {
        this.telIsNull = true
      }
      if (this.liaisionPhoneRadio === '3') {
        this.telIsNull = false
      }
      if (this.liaisionEmailRadio === '1') {
        this.mailIsNull = ''
      }
      if (this.liaisionEmailRadio === '2') {
        this.mailIsNull = true
      }
      if (this.liaisionEmailRadio === '3') {
        this.mailIsNull = false
      }
      if (this.mailSuffixIsNull === '1') {
        this.mailSuffixIsNull = null
      }
      if (this.mailSuffixIsNull === '2') {
        this.mailSuffixIsNull = true
      }
      if (this.mailSuffixIsNull === '3') {
        this.mailSuffixIsNull = false
      }
      console.log(this.addTime)
      if (this.updateTime === null) {
        this.updateTime = []
      }
      if (this.addTime === null) {
        this.addTime = []
      }
      console.log(this.updateTime)
      console.log(this.filterIndex)
      if (this.filterName !== '') {
        this.$http.put('/api/filter/company/' + this.companySideFilter[this.filterIndex].id, {

          companyIds: this.companyValue,
          filterBaseInfo: {
            name: this.filterName,
            scope: this.radioRange,
            type: "COMPANY"
          },
          grade: this.grade,
          groupIds: this.ResponsibleGroup,
          principalIds: this.ResponsiblePerson,
          createTimeBefore: this.addTime[0],
          createTimeAfter: this.addTime[1],
          updateTimeBefore: this.updateTime[0],
          updateTimeAfter: this.updateTime[1],
          mailSuffix: this.mailSuffixIsNull,
          contactPerson: this.lisisonIsNull,
          contactPersonTel: this.telIsNull,
          contactPersonMail: this.mailIsNull,

        }).then(res => {
          if (res.data.code === '0') {
            this.$message.success('修改公司列表过滤器成功')
          } else {
            this.$message.error(res.message)
          }

          this.getShowFilter()
        })
        this.dialogFormVisible2 = false
      } else
        this.$message('请填写过滤器的名称')
    },
    modifyFilter(index, filterId) {
      this.createPersonInput = ''
      this.focusPersonInput = ''
      this.companySelect = ''
      this.addTime = []
      this.updateTime = []
      this.getAccountPerson()
      this.getAccountGroup()
      this.getClientCompany()
      this.filterIndex = index
      this.filterName = this.companySideFilter[index].name
      this.companyValue = this.companySideFilter[index].content.companyIds
      this.ResponsibleGroup = this.companySideFilter[index].content.groupIds
      this.ResponsiblePerson = this.companySideFilter[index].content.principalIds
      if (this.companySideFilter[index].scope === 'MID')
        this.rangeRadio = '1'
      if (this.companySideFilter[index].scope === 'UID')
        this.rangeRadio = '2'
      if (this.companySideFilter[index].content.grade === null)
        this.levelRadio = '1'
      if (this.companySideFilter[index].content.grade === 'NORMAL')
        this.levelRadio = '2'
      if (this.companySideFilter[index].content.grade === 'VIP')
        this.levelRadio = '3'
      if (this.companySideFilter[index].content.contactPersonMail === null)
        this.liaisionEmailRadio = '1'
      if (this.companySideFilter[index].content.contactPersonMail === true)
        this.liaisionEmailRadio = '2'
      if (this.companySideFilter[index].content.contactPersonMail === false)
        this.liaisionEmailRadio = '3'
      if (this.companySideFilter[index].content.contactPersonTel === null)
        this.liaisionPhoneRadio = '1'
      if (this.companySideFilter[index].content.contactPersonTel === true)
        this.liaisionPhoneRadio = '2'
      if (this.companySideFilter[index].content.contactPersonTel === false)
        this.liaisionPhoneRadio = '3'
      if (this.companySideFilter[index].content.contactPerson === null)
        this.liaisionRadio = '1'
      if (this.companySideFilter[index].content.contactPerson === true)
        this.liaisionRadio = '2'
      if (this.companySideFilter[index].content.contactPerson === false)
        this.liaisionRadio = '3'
      if (this.companySideFilter[index].content.createTimeBefore !== null && this.companySideFilter[index].content.createTimeAfter != null) {
        this.addTime = [this.companySideFilter[index].content.createTimeBefore, this.companySideFilter[index].content.createTimeAfter]

      }
      if (this.companySideFilter[index].content.updateTimeBefore !== null && this.companySideFilter[index].content.updateTimeAfter !== null) {
        this.updateTime = [this.companySideFilter[index].content.updateTimeBefore, this.companySideFilter[index].content.updateTimeAfter]

      }
      this.companyFlterId = filterId
      this.dialogFormVisible2 = true

    },
    companyFilter(filterId) {
      this.currentIndex = filterId
      this.$router.push({
        path: '/companyInfo',
        query: {
          id: filterId
        }
      })
    },
    mouseOverClick(index) {
      this.moseOver = index
      this.filterIndex = index
    },
    mouseOutClick() {
      this.moseOver = ''
    },
    resortCompanyFilter() {
      let _this = this;
      let el = document.getElementById('companyFilterResort');
      new Sortable(el, {
        animation: 200,
        ghostClass: 'blue-background-class',
        easing: "cubic-bezier(1, 0, 0, 1)",
        onUpdate: function (event) {
          //修改items数据顺序
          let newIndex = event.newIndex,
              oldIndex = event.oldIndex,
              $li = el.children[newIndex],
              $oldLi = el.children[oldIndex];
          // 先删除移动的节点
          el.removeChild($li)
          // 再插入移动的节点到原有节点，还原了移动的操作
          if (newIndex > oldIndex) {
            el.insertBefore($li, $oldLi)
          } else {
            el.insertBefore($li, $oldLi.nextSibling)
          }
          // 更新items数组
          let item = _this.companyFilterList.list.splice(oldIndex, 1)
          _this.companyFilterList.list.splice(newIndex, 0, item[0])
          // 下一个tick就会走patch更新

        },
      });
      this.resortFilter = _this.companyFilterList.list
      this.companyFilterList.list = _this.companyFilterList.list
    },
    filterLeft(filterId) {
      this.companyFilterList.list.forEach(item => {
        if (item.id === filterId) {
          item.display = false
        }


      })
      console.log(filterId)
    },
    filterToRight(filterId) {
      this.companyFilterList.list.forEach(item => {
        if (item.id === filterId) {
          item.display = true

        }


      })
    },
    filterDisplay() {
      let showList = []
      let hideList = []
      this.companyFilterList.list.forEach(item => {
        if (item.display === false)
          hideList.push(item.id)
        if (item.display === true)
          showList.push(item.id)
      })
      this.$http.post('/api/filter/config', {
        hideList: hideList,
        showList: showList
      }).then(res => {
        if (res.data.code === '0') {
          this.getShowFilter()
          this.$message.success('配置过滤器成功')
        } else
          this.$message.error('配置过滤器失败')
      })
      this.dialogFormVisible1 = false
    },
    cacelFilter() {
      this.getCompanyFilter()
      this.dialogFormVisible1 = false
    },
    deleteCompanyFilter() {
      this.$http.delete('/api/filter/' + this.companyFlterId).then(res => {
        if (res.data.code === '0') {
          this.getShowFilter()
          this.$message.success('删除过滤器成功')

        }

      })
      this.dialogVisible = false
      this.dialogFormVisible2 = false
    },
    IsDeleteCompanyFilter() {
      this.dialogVisible = true
    },
    getAllCompany() {
      this.currentIndex = 0
      this.$router.push({
        path: '/companyInfo',
        query: {
          id: 1
        }
      })
    },

    //点击自定义过滤器
    customizeFilter() {
      this.filterName = ''
      this.companyValue = []
      this.ResponsibleGroup = []
      this.ResponsiblePerson = []
      this.rangeRadio = '1'
      this.levelRadio = '1'
      this.liaisionEmailRadio = '1'
      this.liaisionPhoneRadio = '1'
      this.liaisionRadio = '1'
      this.addTime = []
      this.updateTime = []
      this.dialogFormVisible = true
      this.createPersonInput = ''
      this.focusPersonInput = ''
      this.companySelect = ''
      this.getAccountPerson()
      this.getAccountGroup()
      this.getClientCompany()
    },
    inputCompanyInput(value) {
      if (value !== '') {
        let selectCompany = []
        this.clientCompany.list.forEach((item) => {
          if (!!~item.name.indexOf(value) || !!~item.name.toUpperCase().indexOf(value.toUpperCase())) {
            selectCompany.push(item)
          }
        })
        this.selectCompanyList = selectCompany

      } else {
        this.selectCompanyList = this.clientCompany.list
      }
    },
    inputSelectFilterGroup(value) {
      if (value !== '') {
        let selectCompany = []
        this.accountGroup.list.forEach((item) => {
          if (!!~item.name.indexOf(value) || !!~item.name.toUpperCase().indexOf(value.toUpperCase())) {
            selectCompany.push(item)
          }
        })
        this.selectFilterGroup = selectCompany

      } else {
        this.selectFilterGroup = this.accountGroup.list
      }
    },
    inputSelectFilterPerson(value) {
      if (value !== '') {
        let selectCompany = []
        this.accountPerson.list.forEach((item) => {
          if (!!~item.name.indexOf(value) || !!~item.name.toUpperCase().indexOf(value.toUpperCase())) {
            selectCompany.push(item)
          }
        })
        this.selectFilterPerson = selectCompany

      } else {
        this.selectFilterPerson = this.accountPerson.list
      }
    }

  },
  watch: {
    companyList: function (a) {
      this.companySideFilter = a
    },

  }
}
</script>

<style scoped lang="less">
@import "../../../assets/less/customlist/companylistfilter/companylistfilter";

.companyFilterIsActive {
  color: #409EFF;
}

.blue-background-class {
  background-color: #F1F4F5;
}

.allCompanyCheck {
  color: #409EFF;
}
</style>